var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDocFolder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3.5C4.25 2.80964 4.80964 2.25 5.5 2.25H9.05434V2.52727C9.05434 3.88037 10.1512 4.97727 11.5043 4.97727H11.75V8.83333H7.52967C7.17116 8.83333 6.84009 8.64142 6.66191 8.33032L6.47618 8.00602C6.11983 7.38383 5.45768 7 4.74066 7H4.25V3.5ZM2.75 7.01547V3.5C2.75 1.98122 3.98122 0.75 5.5 0.75H9.38671C9.85437 0.75 10.3026 0.937187 10.6313 1.2698L12.7446 3.40787C13.0684 3.73546 13.25 4.17748 13.25 4.63808V8.84881C14.2366 8.97183 15 9.81343 15 10.8333V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V9C1 7.9801 1.76342 7.1385 2.75 7.01547ZM5.5 4.96584C5.08579 4.96584 4.75 5.30163 4.75 5.71584C4.75 6.13006 5.08579 6.46584 5.5 6.46584H8.29732C8.71153 6.46584 9.04732 6.13006 9.04732 5.71584C9.04732 5.30163 8.71153 4.96584 8.29732 4.96584H5.5ZM13.5 10.8333V13C13.5 13.2761 13.2761 13.5 13 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V9C2.5 8.72386 2.72386 8.5 3 8.5H4.74066C4.91992 8.5 5.08545 8.59596 5.17454 8.75151L5.36028 9.0758C5.80571 9.85355 6.6334 10.3333 7.52967 10.3333H13C13.2761 10.3333 13.5 10.5572 13.5 10.8333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocFolder);
export default __webpack_public_path__ + "static/media/iconDocFolder.0db344e626961bbc9cd997c091c8f2bd.svg";
export { ForwardRef as ReactComponent };